import React from 'react';
import './MobileSearchDock.css';

interface MobileSearchDockProps {
  value: string;
  onChange: (value: string) => void;
  activeFilterCount: number;
  onOpenFilters: () => void;
}

/**
 * Search field and filter button, pinned to the bottom of the viewport.
 *
 * Bottom rather than top so both land in thumb reach on a phone; the results
 * themselves own the rest of the screen.
 */
export const MobileSearchDock: React.FC<MobileSearchDockProps> = ({
  value,
  onChange,
  activeFilterCount,
  onOpenFilters,
}) => (
  <div className="mobile-search-dock">
    <input
      type="text"
      className="mobile-search-input"
      value={value}
      placeholder="Search cards"
      aria-label="Search cards"
      autoComplete="off"
      onChange={(e) => onChange(e.target.value)}
    />
    <button
      type="button"
      className="mobile-filter-button"
      onClick={onOpenFilters}
      aria-label={`Filters${activeFilterCount ? `, ${activeFilterCount} active` : ''}`}
    >
      Filters
      {activeFilterCount > 0 && (
        <span className="mobile-filter-badge">{activeFilterCount}</span>
      )}
    </button>
  </div>
);

export default MobileSearchDock;
